module.exports = __webpack_public_path__ + "img/2_1.2472bec4.png";